import { getDefaultStore } from 'jotai';

import store from 'src/store';
import { ModalType } from 'src/store/modal';

// get default store instance
const jotaiStore = getDefaultStore();

/**
 * Function to open a modal programmatically
 * @param {ModalType} type - The type of modal to open
 * @param {any} data - Data to pass to the modal
 */
export const openModal = (type: ModalType, data: any = undefined) => {
  const onClose = () => {};

  const modalState = jotaiStore.get(store.modal.modalState);
  if (modalState.open && type === 'apiError') {
    console.log('modalState : ', modalState);
    return;
  }

  jotaiStore.set(store.modal.modalState, {
    open: true,
    type,
    data,
    onClose,
  });
};

/**
 * Function to close the modal programmatically
 */
export const closeModal = () => {
  const currentState = jotaiStore.get(store.modal.modalState);
  jotaiStore.set(store.modal.modalState, {
    ...currentState,
    open: false,
    type: undefined,
    data: undefined,
  });
};
